 <nav class="navbar box-shadow app-header" [class.fixed-top]="settings.theme.navbarIsFixed" [class.logo-visible]="showInfoContent">
    <div class="d-flex flex-column w-100">      
        <div class="d-flex justify-content-start align-items-center top-navbar">                  
            
            <a class="logo" routerLink="/" (click)="closeSubMenus()">
                <span class="start">iDrv</span><span class="ng">TMS</span>
            </a>

            <span class="navbar-text menu-icon transition ml-3 mr-3" [ngClass]="{'open': settings.theme.showMenu}"
                (click)="settings.theme.showMenu = !settings.theme.showMenu">
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
            </span>


           <!--  <div class="top-rigth-icons ml-auto"> 
                
                <span class="pl-2 pr-2">
                    <a routerLink="/login">
                        <i class="fa fa-sign-out" aria-hidden="true"></i>
                    </a>                   
                </span> 
            </div>  -->

        </div>

        <div class="horizontal-menu-outer" *ngIf="settings.theme.menu == 'horizontal'">
                   
            <app-horizontal-menu *ngIf="showHorizontalMenu"  [menuItems]="menuItems"></app-horizontal-menu>        
            <app-vertical-menu *ngIf="!showHorizontalMenu"  [menuItems]="menuItems"></app-vertical-menu>

        </div>



    </div>
</nav>
